import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TitreTexteMedia } from '@components/titre-texte-media/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { YoutubePlayerComponent } from '@shared/components/youtube-player';
import { YoutubeIdExtractorPipe } from '@shared/components/youtube-player/pipes';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { IsImagePipe, IsVideoYoutubePipe } from '@shared/pipe';

@Component({
  selector: 'app-titre-texte-media',
  templateUrl: './titre-texte-media.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImageComponent,
    IsImagePipe,
    YoutubeIdExtractorPipe,
    YoutubePlayerComponent,
    TitleComponent,
    HandleHtmlLinksDirective,
    ButtonComponent,
    IsVideoYoutubePipe,
  ],
})
export class TitreTexteMediaComponent extends AbstractDynamicComponent<TitreTexteMedia> {
  protected isLegendVisible = signal(false);
}
